"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRectEdges = exports.getBoundingBoxForElementAndChildren = exports.getRoundedRect = exports.getBoundingBoxForElementRecursive = exports.getBoundingBoxForElement = void 0;
const getBoundingBoxForElement = (element) => {
    const result = element.getBoundingClientRect();
    return {
        x: result.x,
        y: result.y,
        width: result.width,
        height: result.height,
    };
};
exports.getBoundingBoxForElement = getBoundingBoxForElement;
const getBoundingBoxForElementRecursive = (element) => {
    const elementBounds = (0, exports.getBoundingBoxForElement)(element);
    const children = Array.from(element.children).filter(child => child.offsetParent !== null);
    const childrenBounds = children.map(exports.getBoundingBoxForElementRecursive);
    return [
        elementBounds,
        ...childrenBounds
    ].flat();
};
exports.getBoundingBoxForElementRecursive = getBoundingBoxForElementRecursive;
const getRoundedRect = (rect) => ({
    x: Math.round(rect.x),
    y: Math.round(rect.y),
    width: Math.round(rect.width),
    height: Math.round(rect.height),
});
exports.getRoundedRect = getRoundedRect;
const getBoundingBoxForElementAndChildren = (element) => {
    const recursiveBounds = (0, exports.getBoundingBoxForElementRecursive)(element);
    return recursiveBounds.reduce((acc, curr) => {
        const accMaxX = acc.x + acc.width;
        const accMaxY = acc.y + acc.height;
        const currMaxX = curr.x + curr.width;
        const currMaxY = curr.y + curr.height;
        const minX = Math.min(curr.x, acc.x);
        const minY = Math.min(curr.y, acc.y);
        const maxX = Math.max(currMaxX, accMaxX);
        const maxY = Math.max(currMaxY, accMaxY);
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    });
};
exports.getBoundingBoxForElementAndChildren = getBoundingBoxForElementAndChildren;
/* Rect functions */
const getRectEdges = (rect) => ({
    xMin: rect.x,
    yMin: rect.y,
    xMax: rect.x + rect.width,
    yMax: rect.y + rect.height,
});
exports.getRectEdges = getRectEdges;
